import AccountForm from "./accountForm";
import AddressForm from "./addressForm";
import ContractForm from "./contractForm";
import Review from "./review";
import Confirmation from "./Confirmation";
import ServiceForm from "./serviceForm";
import SignersForm from "./signersForm";
import UserForm from "./userForm";

const getInitialState = ({
  relation,
  accountWrappers,
  referenceNumber,
  legalSignerWrappers,
  moduleByProviderWrapper,
  userDataWrappers,
  discountTypeRequest,
  step,
  contractPaRequest,
}) => ({
  currentStep: step ? Number(step) : 0,
  businessId: relation.businessId,
  companyName: relation.companyName,
  referenceNumber,
  address: {
    address: relation.provider?.address,
    city: relation.provider?.residenceCity,
    countryName: relation.provider?.country?.name,
    code: relation.country?.code,
  },
  signers: {
    signer0: legalSignerWrappers?.[0]?.signerName || "",
    identification0: legalSignerWrappers?.[0]?.signerIdentification || "",
    signer1: legalSignerWrappers?.[1]?.signerName || "",
    identification1: legalSignerWrappers?.[1]?.signerIdentification || "",
    signer2: legalSignerWrappers?.[2]?.signerName || "",
    identification2: legalSignerWrappers?.[2]?.signerIdentification || "",
  },
  accounts: accountWrappers.map(
    ({
      accountType,
      accountNumber,
      accountCurrency,
      bicDestinationBank,
      bicIntermediaryBank,
      accountIntermediaryBank,
      id,
    }) => ({
      id,
      accountType,
      accountNumber,
      currency: accountCurrency,
      bicDestinationBank: bicDestinationBank || "No aplica",
      bicIntermediaryBank: bicIntermediaryBank || "No aplica",
      bicAccountIntermediaryBank: accountIntermediaryBank || "No aplica",
      globalApproval:
        discountTypeRequest?.find(({ idAccount }) => idAccount === id)
          ?.globalApproval ?? true,
    })
  ),
  service: {
    modUser: {
      checked: true,
      approvers: moduleByProviderWrapper?.[0]?.numberOfApprovals,
    },
    modBills: {
      checked: true,
      approvers: moduleByProviderWrapper?.[1]?.numberOfApprovals,
    },
    modRelations: {
      checked: true,
      approvers: moduleByProviderWrapper?.[2]?.numberOfApprovals,
    },
    modLogs: true,
    modReports: true,
  },
  user:
    userDataWrappers?.map(
      ({
        codUser,
        email,
        firstName,
        identification,
        lastName,
        modules,
        userIsRegistered,
      }) => ({
        codUser,
        email,
        firstName,
        identification,
        lastName,
        userIsRegistered,
        ...modules.reduce(
          (acc, { id, permissions }) => ({
            ...acc,
            [mods[id]]: permissions.reduce(
              (permissionsAcc, { assigned }, index) => ({
                ...permissionsAcc,
                [permissionsName[index + 1]]: assigned,
              }),
              {}
            ),
          }),
          {}
        ),
      })
    ) || [],
  contractPaRequest:
    relation.provider?.country?.code === "CR"
      ? null
      : contractPaRequest || defaultContractPa,
});

const defaultUserState = {
  firstName: "",
  lastName: "",
  email: "",
  codUser: null,
  identification: "",
  userIsRegistered: false,
  modRelations: {
    approval: false,
    capture: false,
    query: false,
  },
  modUser: {
    approval: false,
    capture: false,
    query: false,
  },
  modBills: {
    approval: false,
    capture: false,
    query: false,
  },
};

const availableSteps = [
  { Component: AddressForm, name: "address" },
  {
    Component: SignersForm,
    name: "signers",
    requestData: (value) => ({
      legalSignerRequests: [0, 1, 2].flatMap((id) => {
        const signerName = value[`signer${id}`];
        const signerIdentification = value[`identification${id}`];
        return !signerName ? [] : { signerName, signerIdentification };
      }),
    }),
  },
  {
    moduleRequest: [
      {
        moduleId: 0,
        numberOfApprovals: 0,
      },
    ],

    Component: AccountForm,
    name: "accounts",
    requestData: (data) =>
      data.reduce(
        (acc, { id, globalApproval }) => {
          acc.discountTypeRequests.push({ idAccount: id, globalApproval });
          return acc;
        },
        { discountTypeRequests: [] }
      ),
  },
  {
    Component: ServiceForm,
    name: "service",
    requestData: (value) => ({
      moduleRequest: [
        "modUser",
        "modBills",
        "modRelations",
        "modLogs",
        "modReports",
      ].map((name, index) => ({
        moduleId: index + 1,
        ...(value[name]?.approvers && {
          numberOfApprovals: value[name].approvers,
        }),
      })),
    }),
  },
  {
    Component: UserForm,
    name: "user",
    requestData: (users) => ({
      userRequest: users.map(
        ({ modUser, modBills, modRelations, ...restUser }) => ({
          data: {
            ...restUser,
            modules: [modUser, modBills, modRelations].map((mod, index) => {
              const id = String(index + 1);
              return {
                id,
                permissions: Object.keys(mod).map((key, keyIndex) => ({
                  idAlternative: `${id}.${keyIndex + 1}`,
                  assigned: mod[key],
                })),
              };
            }),
          },
        })
      ),
    }),
  },
  {
    Component: ContractForm,
    name: "contractPaRequest",
    requestData: (contractPaRequest) => ({ contractPaRequest }),
  },
  { Component: Review, requestData: () => ({}) },
  { Component: Confirmation },
];

const mods = {
  1: "modUser",
  2: "modBills",
  3: "modRelations",
};

const permissionsName = {
  1: "approval",
  2: "capture",
  3: "query",
};

const defaultContractPa = {
  providerName: "",
  representativeName: "",
  city: "",
  society: "",
  gender: "",
  businessIdType: "",
  country: "",
  nationality: "",
  businessId: "",
  registered: "",
  maritalStatus: "",
  conditional: "",
  from: "",
  profession: "",
  consists: "",
  address: "",
};

const getSteps = (country) => {
  return country === "CR"
    ? availableSteps.filter(({ name }) => name !== "contractPaRequest")
    : availableSteps;
};

export { defaultUserState, getInitialState, getSteps };
